import { Component, input, output } from '@angular/core';
import { ListPatientsByTenantIdQuery } from '@insolution/graphql-data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalDateFormatPipe } from '@insolution/language-ui';

@Component({
  selector: 'lib-patients-table',
  imports: [TranslatePipe, LocalDateFormatPipe],
  templateUrl: './patients-table.html',
  styleUrl: './patients-table.scss',
})
export class PatientsTable {
  patients = input<ListPatientsByTenantIdQuery['listPatientsByTenantId']>();
  clickedTableRow = output<string>();
  startConsultEmitter = output<string>();

  public onClickTableRow(patientId: string): void {
    this.clickedTableRow.emit(patientId);
  }
}
